import { QueryKeys } from '../../../queryKeys';
import { getRequest } from '../../../helpers/apiClient';
import apiRoutes from '../../../api-routes';
import { useQueryWithLogout } from '../../../hooks/useQueryWithLogout';

export const useYearlyReport = (options) =>
  useQueryWithLogout(
    [QueryKeys.YEARLY_REPORT],
    async () => {
      const { data } = await getRequest({
        url: apiRoutes.YEARLY_REPORT,
      });
      return data;
    },
    options,
  );
